/** Подпись, когда у сессии не назначен чтец (вместо прочерка). */
export const SESSION_READER_NOT_SET_LABEL = 'Чтец не указан';

/** Подпись, когда у сессии не выбран проект. */
export const SESSION_NO_PROJECT_LABEL = 'Проект не выбран';
